export const themeOptions = {
  palette: {
    type: "light",
    primary: {
      main: "#02a93f",
    },
    secondary: {
      main: "#FF81D1",
    },
    background: {
      default: "#f4f604",
    },
    warning: {
      main: "#FC300B",
    },
    divider: "#FC300B",
  },
  spacing: 12,
  shape: {
    borderRadius: 0,
  },
};
